import React from "react";
import css from "./NoticeView.module.css";
import {TextView} from "Components";
import {alert0} from "Assets";


export default function NoticeView(props){
    const {icon,text=props.children}=props;
    return (
        <div className={`${css.noticeview} ${props.className||""}`} style={props.style}>
            <img className={css.icon} alt="" src={typeof(icon)==="function"?icon(mainColor):icon}/>
            <TextView className={css.text} text={text}/>
        </div>
    )
}

NoticeView.defaultProps={
    icon:alert0,
}
